import { render, staticRenderFns } from "./live_chat.vue?vue&type=template&id=c392ca24&"
import script from "./live_chat.vue?vue&type=script&lang=js&"
export * from "./live_chat.vue?vue&type=script&lang=js&"
import style0 from "./live_chat.vue?vue&type=style&index=0&id=c392ca24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LiveChatMessage: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/live_chat_message.vue').default})
